module.exports = {
    blog_title:'Blog Taption',
    blog_desc:'Artikel bermanfaat dan saran praktis untuk para pembuat konten. Pembaruan produk, berita, dan informasi dari Taption.',
    written_by: 'Ditulis oleh', 
}
